module.exports = __webpack_public_path__ + "media/nujabes-luv-sic-pt-3-ftshing02.38727212.mp3";